import * as Types from '../../@types/graphql-types';

import gql from 'graphql-tag';
export type GetListsCountQueryVariables = Types.Exact<{
	type: Types.GenericTitleListsType;
}>;

export type GetListsCountQuery = {
	__typename?: 'Query';
	genericTitleLists: { __typename?: 'GenericTitleListsConnection'; totalCount: number };
};

export const GetListsCountDocument = gql`
	query GetListsCount($type: GenericTitleListsType!) {
		genericTitleLists(type: $type) {
			totalCount
		}
	}
`;
